import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { MiniStoreThemeContext } from "../../../MiniStoreContexts/MiniStoreThemeContext";
import { Rating } from "react-simple-star-rating";
import { HiShoppingBag } from "react-icons/hi2";
import { CartContext } from "../../../contexts/MiniStore/CartContext";

const ProductCard = ({
  id,
  variant_ids,
  title,
  rating,
  quantity,
  price,
  newPrice,
  has_discounted_price,
  img,
  currency,
  description,
  onQuantityChange,
  onAddToCart,
  onClick,
  viewType,
  hasVariant,
  fromShop = false,
}) => {
  const { theme } = useContext(MiniStoreThemeContext);
  const { cart } = useContext(CartContext);
  const [isLoadingAddToBag, setIsLoadingAddToBag] = useState(false);
  const [isLoadingAddIcons, setIsLoadingAddIcons] = useState(false);
  // console.log("newPrice ----- price", Number(newPrice), Number(price));
  // Check if the product is in the cart
  const isInCart = cart.some((item) => variant_ids?.includes(item.variant_id));

  const handleAddToCart = async (...args) => {
    setIsLoadingAddToBag(true);
    await onAddToCart(...args);
    setIsLoadingAddToBag(false);
  };
  if (fromShop) {
    return (
      <Card theme={theme} id={id} onClick={onClick}>
        <ShopViewWrapper>
          <Img src={img} />
          <Title>{title}</Title>
        </ShopViewWrapper>
      </Card>
    );
  }

  const increaseQty = async () => {
    setIsLoadingAddIcons(true);
    await onQuantityChange(id, 1);
    setIsLoadingAddIcons(false);
  };
  const decreaseQty = async () => {
    setIsLoadingAddIcons(true);
    if (quantity > 0) await onQuantityChange(id, -1);
    setIsLoadingAddIcons(false);
  };

  return (
    <Card theme={theme} id={id} viewType={viewType}>
      <ViewWrapper viewType={viewType}>
        <Img src={img} onClick={onClick} viewType={viewType} />
        <InfoWrapper viewType={viewType}>
          <Title viewType={viewType} onClick={onClick}>
            <TitleText>{title}</TitleText>
          </Title>
          <RatingContainer>
            <Rating initialValue={rating || 0} readonly size={20} />
          </RatingContainer>
          <PriceContainer>
            {Number(newPrice) < Number(price) && has_discounted_price ? (
              <>
                <Price theme={theme}>{currency}</Price>
                <OverlinedPrice theme={theme}>{price}</OverlinedPrice>
                <Price theme={theme}>{newPrice}</Price>
              </>
            ) : (
              <Price theme={theme}>
                {currency} {newPrice}
              </Price>
            )}
          </PriceContainer>

          <ControlsContainer viewType={viewType}>
            <QuantityControl theme={theme} viewType={viewType}>
              <Icon
                disabled={isLoadingAddIcons}
                theme={theme}
                className="fa-solid fa-minus"
                onClick={hasVariant ? handleAddToCart : decreaseQty}
              />
              <Count theme={theme} viewType={viewType}>
                {quantity}
              </Count>
              <Icon
                disabled={isLoadingAddIcons}
                theme={theme}
                className="fa-solid fa-plus"
                onClick={handleAddToCart}
              />
            </QuantityControl>
            <AddToBagButton
              theme={theme}
              disabled={isLoadingAddToBag || isInCart}
              onClick={handleAddToCart}
            >
              Add
            </AddToBagButton>
          </ControlsContainer>
        </InfoWrapper>
      </ViewWrapper>
    </Card>
  );
};

export default ProductCard;

// Styled Components

const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${({ viewType }) => (viewType === "grid" ? "start" : "start")};
  // padding-top: 0.5rem;
  max-width: ${({ viewType }) => (viewType === "grid" ? "280px" : "500px")};
  cursor: pointer;
  background: #fff;
  // padding: 16px;
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  // transition: transform 0.2s ease-in-out;

  // &:hover {
  //   transform: translateY(-5px);
  // }
  @media (max-width: 527px) {
    width: 100%;
    // padding: 12px;
  }
`;

const Img = styled.img`
  height: ${({ viewType }) => (viewType === "grid" ? "248px" : "184px")};
  width: 100%;
  max-width: ${({ viewType }) => (viewType === "grid" ? "100%" : "184px")};
  border-top-left-radius: 0.15rem;
  border-top-right-radius: ${({ viewType }) =>
    viewType === "grid" ? "0.15rem" : "0rem"};
  border-bottom-left-radius: ${({ viewType }) =>
    viewType === "grid" ? "0rem" : "0.15rem"};
  @media (max-width: 768px) {
    height: 196px;
    width: 100%;
  }
  @media (max-width: 527px) {
    // height: 100%;
    width: 100%;
  }
  @media (max-width: 425px) {
    height: 140px;
    width: 100%;
    max-width: ${({ viewType }) => (viewType === "grid" ? "100%" : "120px")};
    min-width: ${({ viewType }) => (viewType === "grid" ? "100%" : "120px")};
  }
`;
const Title = styled.div`
  font-family: Outfit, sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 29px;
  width: 100%;
  display: flex;
  justify-content: ${({ viewType }) =>
    viewType === "grid" ? "start" : "start"};
  padding-top: 0.5rem;
  @media (max-width: 375px) {
    padding-top: 0rem;
  }
`;
const TitleText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  @media (max-width: 768px) {
    width: 200px;
  }
  @media (max-width: 527px) {
    width: 150px;
  }
  @media (max-width: 425px) {
    max-width: 120px;
    font-size: 12px;
  }
`;
const RatingContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: flex-start;
  // overflow: hidden;

  .star-svg {
    max-width: 100%;
    height: auto;
    flex-shrink: 1;
  }
`;
const CartIcon = styled(HiShoppingBag)`
  color: ${({ theme }) => theme.textColor.primary};
  font-size: 26px;
  &:hover {
    color: ${({ theme }) => theme.textColor.secondary};
  }
`;
const OverlinedPrice = styled.span`
  text-decoration: line-through;
  color: #9c9a9a;
  ont-family: Outfit;
  font-size: 18px;
  line-height: 29px;
  font-weight: 700;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  @media (max-width: 425px) {
    font-size: 12px;
    margin-right: 0.15rem;
    margin-left: 0.15rem;
  }
`;
const PriceContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin: 0.5rem 0rem;
  // @media (max-width: 512px) {
  //   flex-direction: column;
  // }
  @media (max-width: 375px) {
    margin: 0rem;
  }
`;
const Price = styled.div`
  ont-family: Outfit;
  font-size: 18px;
  line-height: 29px;
  font-weight: 700;
  color: ${({ theme }) => theme.primaryColor.primary};
  @media (max-width: 425px) {
    font-size: 12px;
  }
`;
const Currency = styled.div`
  ont-family: Outfit;
  font-size: 22px;
  line-height: 29px;
  font-weight: 700;
  margin-left: 0.5rem;
  color: ${({ theme }) => theme.primaryColor.primary};
`;
const ControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ viewType }) => (viewType === "grid" ? "" : "20px")};
  width: 100%;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 527px) {
    flex-direction: column;
  }
`;
const QuantityControl = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  padding: 5px 10px;
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  width: 50%;
  @media (max-width: 527px) {
    width: 100%;
  }
`;
const Count = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.primaryColor.primary};
  margin: 0 10px;
  width: 100%;
  text-align: center;
`;
const Icon = styled.i`
  cursor: pointer;
  color: #fff;
  background: ${({ theme, disabled }) =>
    disabled ? "silver" : theme.primaryColor.primary};
  border-radius: 0.15rem;
  padding: 2px;
`;
const AddToBagButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: ${({ theme, disabled }) =>
    disabled ? "silver" : theme.primaryColor.primary};
  color: ${({ theme }) => theme.textColor.primary};
  border: none;
  padding: 8px 16px;
  border-radius: 0.15rem;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  font-weight: 600;
  font-size: 16px;
  font-family: Outfit, sans-serif;
  transition: background 0.2s ease-in-out;
  width: 50%;
  @media (max-width: 527px) {
    width: 100%;
  }
  &:hover {
    background: ${({ theme, disabled }) =>
      disabled ? "silver" : theme.primaryColor.secondary};
    color: ${({ theme, disabled }) =>
      disabled ? theme.textColor.primary : theme.textColor.secondary};

  svg {
    color: ${({ theme, disabled }) =>
      disabled ? theme.textColor.primary : theme.textColor.secondary};
  }
  
`;
const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1rem;
  @media (max-width: 425px) {
    padding: ${({ viewType }) =>
      viewType === "grid" ? "1rem" : "0rem 1rem 1rem 1rem"};
  }
`;

const ViewWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: ${({ viewType }) => (viewType === "grid" ? "start" : "center")};
  flex-direction: ${({ viewType }) => (viewType === "grid" ? "column" : "row")};
  // gap: 10px;
  @media (max-width: 425px) {
    padding: ${({ viewType }) =>
      viewType === "grid" ? "0rem" : "1rem 0rem 1rem 1rem"};
  }
`;
const ShopViewWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 15px;
`;
